import { configSkimlinks } from "@pub/config";
import { loadScript } from "@sphtech/dmg-design-system";
import { useEffect } from "react";

declare global {
  interface Window {
    Genius: {
      amazon: {
        addOnClickRedirect(a: string, b: boolean, c: string): void;
      };
    };
  }
}

function getGeniusLink(url: string) {
  const AMAZON_URL_REGEX =
    /^(?:https?:\/\/)?(?:[\w-]+\.)*(?:amazon(?:\.[\w]{2,4})+|amzn\.to)(?:\/.*)?$/i;

  if (AMAZON_URL_REGEX.test(url)) {
    const geniusBaseDomain = "https://buy.geni.us";
    return new URL(
      `Proxy.ashx?tsid=${configSkimlinks.geniuslinkId}&GR_URL=${encodeURI(url)}`,
      geniusBaseDomain,
    ).toString();
  }
  return url;
}

function AnalyticsSkimlinks() {
  useEffect(() => {
    const geniuslinkFile = `//geniuslinkcdn.com/snippet.min.js`;
    const skimlinksFile = `https://s.skimresources.com/js/${configSkimlinks.skimlinkId}.skimlinks.js`;
    loadScript(geniuslinkFile, true).then(
      () => {
        window.Genius.amazon.addOnClickRedirect(
          configSkimlinks.geniuslinkId,
          true,
          "https://buy.geni.us",
        );
        void loadScript(skimlinksFile, true);
      },
      () => {},
    );
  }, []);
  return null;
}

export default configSkimlinks.active ? AnalyticsSkimlinks : () => null;
export { getGeniusLink };
